import React from 'react';
import store from '../store';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const stylesBt = theme => ({
    button: {
        margin: theme.spacing.unit,
        position: 'fixed',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
});
let tick;
class NumDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      second:props.second?props.second:0,
      showing:props.showing?props.showing:false,
      interval:null,
      index:0,
      isEnd:false,
      enableSound:false,
      numbers:props.numbers?props.numbers:[],
      sound:props.sound?props.sound:0,
      type:props.type?props.type:0

    }
    //console.log(props);

  }
  componentDidMount(){
      this.startShowing();
  }
  playAudio(audios,aIndex,interval,container)
  {
    if(aIndex<audios.length)
    {
      let audio = audios[aIndex];
      audio.audio.onended = function (){

        aIndex++;
        if(audio.type==0)
        setTimeout(()=>{
          container.playAudio(audios,aIndex,interval,container);
        },interval);
        else {
          container.playAudio(audios,aIndex,interval,container);
        }

      }
      audio.audio.play()
    }
    else {
      container.setState({isEnd:true});
      container.props.isEnd();

    }
  }
  playAudio2(audios,interval)
  {
    let _this = this;
    let index = 0;
    for(let a of audios)
    {
      if(index==0)
      {
        a.audio.currentTime = 0;
        a.audio.play();
      }
      else {
        setTimeout(()=>{
          a.audio.currentTime = 0;
          a.audio.play();
        },interval*index)
      }
      index++;
    }
    setTimeout(()=>{
      _this.setState({isEnd:true});
      _this.props.isEnd();
    },(interval*(index-1))+1000);


  }
  getURI(LANG,key)
  {
    let aList = this.props.aList;
    let uri = "assets/sound/"+LANG+"/"+LANG+"_"+key+".mp3";
    if(aList)
    {
      let t = aList[LANG+"_"+key];
      if(t)
      {
        uri = t;
      }
    }
    console.log(uri);
    return uri;
  }
  getAudio(LANG,key)
  {
    let aList = this.props.aList;
    let audio = null;
    if(aList)
    {
      let t = aList[LANG+"_"+key];
      if(t)
      {
        audio = t;
      }
    }
    else 
    {
      return new Audio(this.getURI(LANG,key));
    }
   
    return audio;
  }
  startShowing(){
    if(this.state.second>0&&this.state.numbers.length>0&&!this.state.isEnd)
    {
      let _this=this;
      let interval = Math.floor(this.state.second*1000/this.state.numbers.length);
      let intervalCount = interval-1000;
      let numb  = this.state.numbers[_this.state.index];
      //let audio;
      let intervalRate = 1000/interval;
      if(numb>100)
      {
        intervalCount=intervalCount-2000;
        intervalRate = 2000/interval;
      }

    //  console.log(interval,intervalRate,intervalCount);
      let audioRate = intervalRate;
      if(intervalRate<=1)
      {
        audioRate=1;
      }
      else {

        //audioRate = 1+(1-intervalRate);
      }

      let enableSound = false;
      let totalTime = 0;
      let countA = 0;
      let intervalA = 1000;
      let intervalB = 0;
      if(this.state.sound)
      {
        for(let i=0;i<this.state.numbers.length;i++)
        {
          let n = this.state.numbers[i];
          totalTime+=(n<0?2:1);
          countA+=(n<0?2:1);
        }

        if(totalTime<=this.state.second)
        {
          intervalB = Math.floor((this.state.second-totalTime)*1000/(countA-1));
          audioRate = 1;
        }
        else {
          intervalA = Math.floor(this.state.second*1000/countA);
          audioRate = 1000/intervalA;
        }
        console.log("totalTime",totalTime,this.state.second,countA,intervalA,intervalB,audioRate);
        if(audioRate<=3)
        {
          if(this.state.sound)
          enableSound = true;
        }
      }
      this.setState({enableSound});
      //console.log(audioRate);
      let audios = [];

      //if(audioRate<=2&&this.state.sound&&numb<1000)
      if(enableSound)
      {
        let LANG = store.getState().LANG;
        //if(LANG=='vi')
        //{
          LANG = 'vn2';
        //}
        if((this.state.type!='multiple'&&this.state.type!='divide'))
        {
          for(let i=0;i<this.state.numbers.length;i++)
          {
            let n = this.state.numbers[i];
            n = parseInt(n.toString().replace('x','').replace('÷',''));
            if(n<0)
            {

                let audio =  _this.getAudio(LANG,"minus");
              //  audio.playbackRate = audioRate+audioRate*3/4;
              audio.playbackRate = audioRate;
              audio.currentTime = 0;
                audios.push({audio:audio,type:1});
                let audio2 = _this.getAudio(LANG,Math.abs(n).toString());
                //audio2.playbackRate = audioRate+audioRate/4;
                audio2.playbackRate = audioRate;
                audio2.currentTime = 0;
                audios.push({audio:audio2,type:0});;
            }
            else {

                let audio =  _this.getAudio(LANG,n.toString());
                audio.playbackRate = audioRate;
                audio.currentTime = 0;
                audios.push({audio:audio,type:0});;

            }
          }
          let audio = _this.getAudio(LANG,"equal");
          audio.playbackRate = 1;
          audio.currentTime = 0;
          audios.push({audio:audio,type:0});;
          if(audios.length>0)
          {
            this.playAudio2(audios,intervalA+intervalB);
          }
          return;
        }



        for(let i=0;i<this.state.numbers.length;i++)
        {
          let n = this.state.numbers[i];
          n = parseInt(n.toString().replace('x','').replace('÷',''));
          if(n<0)
          {
              let audio =  new Audio("assets/sound/"+LANG+"/"+LANG+"_"+"minus.mp3");
            //  audio.playbackRate = audioRate+audioRate*3/4;
            audio.playbackRate = audioRate;
              audios.push({audio:audio,type:1});
              let audio2 = new Audio("assets/sound/"+LANG+"/"+LANG+"_"+Math.abs(n)+".mp3");
              //audio2.playbackRate = audioRate+audioRate/4;
              audio2.playbackRate = audioRate;
              audios.push({audio:audio2,type:0});;
          }
          else {
            if((this.state.type=='multiple'||this.state.type=='divide') && i!=0)
            {
              let audio =  new Audio("assets/sound/"+LANG+"/"+LANG+"_"+(this.state.type=='multiple'?'multi':'divide')+".mp3");
            //  audio.playbackRate = audioRate+audioRate*3/4;
            audio.playbackRate = audioRate;
              audios.push({audio:audio,type:1});;
              let audio2 = new Audio("assets/sound/"+LANG+"/"+LANG+"_"+Math.abs(n)+".mp3");
            //  audio2.playbackRate = audioRate+audioRate/4;
            audio2.playbackRate = audioRate;
              audios.push({audio:audio2,type:0});;
            }
            else {
              let audio = new Audio("assets/sound/"+LANG+"/"+LANG+"_"+n+".mp3");
              audio.playbackRate = audioRate;
              audios.push({audio:audio,type:0});;
            }
          }
        }
        let audio = new Audio("assets/sound/"+LANG+"/"+LANG+"_"+"equal.mp3");
        audio.playbackRate = audioRate;
        audios.push({audio:audio,type:0});;
        let aIndex = 0;

        if(audios.length>0)
        {
          this.playAudio(audios,aIndex,intervalCount>0?intervalCount:0,this);

          return;
        }


      }
      _this.props.updateEQMessage(_this.state.index);
       tick = setInterval(function(){
  // do your thing

      if(_this.state.index>=_this.state.numbers.length-1){
        clearInterval(tick);
        _this.props.isEnd();
        _this.setState({isEnd:true});
      }
      else {
          let numb2  = _this.state.numbers[_this.state.index+1];
          numb2 = numb2.toString().replace('x','').replace('÷','');
          numb2 = parseInt(numb2);
          // if(audioRate<=2&&_this.state.sound&&numb2<1000)
          // {
          //   if(numb2<0)
          //   {
          //
          //   audio =  new Audio("assets/sound/vn/minus.mp3");
          //   audio.playbackRate = audioRate+audioRate*3/4;
          //   audio.play();
          // //  console.log('test',(intervalRate/3)*1000);
          //   setTimeout(()=>{
          //     audio = new Audio("assets/sound/vn/"+Math.abs(numb2)+".mp3");
          //     audio.playbackRate = audioRate+audioRate/4;
          //     audio.play();
          //   },(intervalRate/4)*1000)
          //   }
          //   else {
          //     if(_this.state.type=='multiple'||_this.state.type=='divide')
          //     {
          //
          //       audio =  new Audio("assets/sound/vn/"+(_this.state.type=='multiple'?'multi':'divide')+".mp3");
          //       audio.playbackRate = audioRate+audioRate*3/4;
          //       audio.play();
          //     //  console.log('test',(intervalRate/3)*1000);
          //       setTimeout(()=>{
          //         audio = new Audio("assets/sound/vn/"+Math.abs(numb2)+".mp3");
          //         audio.playbackRate = audioRate+audioRate/4;
          //         audio.play();
          //       },(intervalRate/4)*1000)
          //     }
          //     else {
          //       audio = new Audio("assets/sound/mp3/"+numb2+".mp3");
          //
          //       audio.play();
          //     }
          //
          //   }
          //
          // }
        _this.setState({index:_this.state.index+1});

        _this.props.updateEQMessage(_this.state.index);
      }
    },interval);
  }
  }
  componentWillReceiveProps(props)
  {
    if(props.showing&&this.state.isEnd)
    {
      this.setState({showing:true,isEnd:false,index:0,numbers:props.numbers,second:props.second},()=>this.startShowing());
    }
    if(props.sound!=this.state.sound)
  {
    this.setState({sound:props.sound});
  }
  }
  componentWillUnmount(){
    if(tick)
    clearInterval(tick);
  }

  getDisplayText(){
    let rel = '';
    let {second,index,isEnd,numbers,type} = this.state;
    let isSame=false;

    if(isEnd)
    rel = '=';
    else {
      if(numbers.length>0)
      {
        if(index==0)
          {
            rel +=parseFloat(numbers[index]).toLocaleString('en-US');
          }
          else {
            if(numbers[index-1]<0&&numbers[index]>0)
            {
              rel +='+'+parseFloat(numbers[index]).toLocaleString('en-US');
            }
            else {
              if(type=='multiple'||type=='divide')
              {
              //  console.log(parseFloat(numbers[index].toString().replace('x','').replace('÷','')));
                rel += (type=='multiple'?'x':'÷')+parseFloat(numbers[index].toString().replace('x','').replace('÷','')).toLocaleString('en-US');
              }
              else
              rel +=parseFloat(numbers[index]).toLocaleString('en-US');
            }
            if(numbers[index-1]==numbers[index])
            {
              isSame=true;
            }
            if(isSame&&index>=2)
            {
              if(numbers[index-2]==numbers[index])
              {
                isSame=false;
              }
            }
          }
      }
    }
    if(isSame)
    return (<span style={{color:"#b71c1c"}}>{rel}</span>)
    else
    return rel;
  }

    render() {
        const { classes, width,size } = this.props;
        let {second,index,isEnd,numbers,enableSound} = this.state;
        //console.log(numbers);
        let bWidth = width*0.2;
        let bStyle = {width:bWidth,height:bWidth}
        return (
            <div style={{fontSize:size?size:"10rem",color:"white",fontFamily:'arial',display:'flex',justifyContent:'center',alignItems:'center'}}>
                {enableSound&&!isEnd?<img
                    src="assets/comp/speaker.png"
                    style={bStyle} />:this.getDisplayText()}
            </div>
        );
    }
}

NumDisplay.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(stylesBt)(NumDisplay);
